import $ from 'jquery';

// The services used to for downloading PDFs
// TODO: Create a helper method to pass the byte[] to the client as a .pdf file

export function getPdf(manufacturer, partNumber) {
    let endpoint = '/api/product/pdf/' + manufacturer + '/' + partNumber;

    return new Promise(function (resolve, reject) {
        let endpoint = '/api/product/pdf/' + manufacturer + '/' + partNumber;
        let xhr = new XMLHttpRequest();

        xhr.open("GET", endpoint);
        xhr.responseType = "arraybuffer";

        xhr.onload = function(){
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            }
            else {
                reject({
                    status: this.status,
                    statusText: xhr.statusText
                });
            }
        }

        xhr.onerror = function(){
            reject({
                status: this.status,
                statusText: xhr.statusText
            })
        }

        xhr.send();
    });
}


// WEBPACK FOOTER //
// ./assets/services/ProductDetailPdfService.js